define('core/modules/breakdance',["jquery", "libs/enquire", "core/global/helpers"], function ($, enquire, helpers) {
    return {
        register: function (bp, matchCallback, unmatchCallback) {
            enquire.register("screen and (max-width : " + bp + "px)", {                           
                match: function () {
                    matchCallback = helpers.getFuncFromString(matchCallback);
                    matchCallback();
                },
                unmatch: function () {
                    unmatchCallback = helpers.getFuncFromString(unmatchCallback);
                    unmatchCallback();
                }              
            });
        }
    }
});
